import React from "react";

import { useTranslation } from "utils";

import { Flex, Icon, Spin } from "components";

const LoadingState = ({ text, year }: { text: string; year: number }) => (
  <Flex data-testid={`recommendation-card-${year}-loading`} gap="0.5rem" justify="left" align="center" style={{ height: "100%" }}>
    <Spin color="#6D6D6D" />
    <p className="paragraph-s bold">{text}</p>
  </Flex>
);

export type RecommendationCardProps = {
  year: number;
  isLoading?: boolean;
  isActive?: boolean;
};

export const RecommendationCard = ({ year, isLoading, isActive }: RecommendationCardProps) => {
  const { t } = useTranslation("cropExplorer");

  return (
    <Flex data-testid={`recommendation-card-${year}`} className={`recommendation-card ${isActive && "active"} layout`} justify="center" vertical={true}>
      {isLoading ? (
        <LoadingState text={t("recommendation.card.loading")} year={year} />
      ) : (
        <>
          <Flex align="start" style={{ width: "auto" }}>
            <span data-testid={`recommendation-card-${year}-title`} className="recommendation-card name">
              {t("recommendation.card.title")}
            </span>
            <Icon dataTestId={`recommendation-card-${year}-icon`} className="recommendation-card recommendation-card-icon" iconName="tabler/bulb" />
          </Flex>
          <span data-testid={`recommendation-card-${year}-description`} className="recommendation-card description">
            {t("recommendation.card.description")}
          </span>
        </>
      )}
    </Flex>
  );
};
